import {GroupAvatar, UserAvatar} from "@/lib/types";
import {Pressable, StyleSheet, Text} from "react-native";
import Avatar from "@/lib/components/Avatar";
import {Color} from "@/lib/styles";
import Icon from "@/lib/components/Icon";
import Badge from "@/lib/components/Badge";
import Split from "@/lib/components/Split";
import {useAccount} from "@/lib/components/AccountProvider";

type Props = {
    avatar: UserAvatar | GroupAvatar,
    color: string,
    contrastColor: string,
    badgeColor: string,
    badge?: string,
    checked?: boolean,
    onPress: (avatar: UserAvatar | GroupAvatar) => any,
    onEdit?: () => any,
}

export default function AvatarRow(props: Props) {
    const isEditable = props.onEdit !== undefined;
    const userAvatar = props.avatar as UserAvatar;
    const groupAvatar = props.avatar as GroupAvatar;
    const {isFriend} = useAccount();

    return (
        <Pressable style={[styles.container, {backgroundColor: props.color}]} onPress={() => props.onPress(props.avatar)}>
            <Split left={
                <>
                    <Avatar avatar={props.avatar} pressable={false}/>
                    {!!userAvatar.gecos && <Text style={styles.username}>{userAvatar.gecos}</Text>}
                    {!!groupAvatar.name && <Text style={styles.username}>{groupAvatar.name}</Text>}
                    {!!userAvatar.gecos && isFriend(userAvatar.id) && <Icon kind={"relation"}/>}
                    {!!props.badge && <Badge color={props.badgeColor} contrastColor={props.contrastColor} title={props.badge}/>}
                </>
            } right={
                <>
                    {props.checked && <Icon kind={"checkmark"} size={22}/>}
                    {isEditable && <Pressable onPress={props.onEdit} style={styles.editableContainer}><Icon kind={"edit"} size={16}/></Pressable>}
                </>
            }/>
        </Pressable>
    )
}

export const styles = StyleSheet.create({
    container: {
        width: "100%",
        height: 48,
        justifyContent: "center",
        paddingLeft: 8,
    },
    editableContainer: {
        height: 48,
        width: 48,
        justifyContent: "center",
        alignItems: "center",
    },
    left: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        flexGrow: 1,
        gap: 8,
    },
    right: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 8,
    },
    username: {
        color: Color.PrimaryText,
        fontSize: 16,
        flexShrink: 1,
    }
})